<!-- <app-header></app-header> -->
<!-- {{ message | async | json }} -->
<router-outlet></router-outlet>
<ngx-spinner type = "ball-pulse" size = "medium"></ngx-spinner>
<!-- <app-footer></app-footer> -->
